let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i2vEA")).then(() => parcelRequire('8bOb4'));